module.exports = __webpack_public_path__ + "img/15.700b6060.png";